import React, { Suspense } from "react";
import PropTypes from "prop-types";
import Loader from "./loader";

const LazyWrapper = ({ children }) => (
	<Suspense fallback={<Loader />}>{children}</Suspense>
);

LazyWrapper.propTypes = {
	children: PropTypes.node.isRequired
};

export default LazyWrapper;
